import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { lensProp, set } from "ramda";
import Grid from "@material-ui/core/Grid";
import { notBlank } from "../../util/ext";
import { useAssociatedOrganizationCreate } from "../organizationServices";
import {
  validateAssociated,
  validateAssociatedField,
} from "../organizationValidation";
import OrganizationAutoComplete from "../../user-admin/OrganizationAutoComplete";
import CredentialTypeSelect from "./CredentialTypeSelect";
import { useErrorBox } from "./use-errorBox";

const OrganizationPropertyDialog = ({
  organizationId,
  open,
  onCancel,
  onSave,
}) => {
  const [fields, setFields] = useState({
    associatedOrganizationId: null,
    credentialType: null,
  });

  const {
    addValidationError,
    removeValidationError,
    setValidationErrors,
    setGeneralError,
    hasValidationError,
    firstValidationError,
    ErrorBox: DialogErrors,
  } = useErrorBox();

  const onFieldChange = field => value => {
    const update = set(lensProp(field), value, fields);
    setFields(update);
  };

  const handleBlur = (field, value) => {
    const validationErrors = validateAssociatedField(field, value);
    if (notBlank(validationErrors)) {
      addValidationError(validationErrors);
    } else {
      removeValidationError(field);
    }
  };

  const associatedOrgCreate = useAssociatedOrganizationCreate();
  const handleApply = async () => {
    const validationErrors = validateAssociated(fields);
    if (notBlank(validationErrors)) {
      setValidationErrors(validationErrors);
    } else {
      try {
        await associatedOrgCreate.mutateAsync({
          resourceIds: { orgId: organizationId },
          data: fields,
        });
        onSave(fields);
      } catch (err) {
        setGeneralError(err);
      }
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="form-dialog-title">
        New Associated Organization
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select an Organization and Authentication Type
        </DialogContentText>
        <DialogErrors />
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <OrganizationAutoComplete
              autoFocus
              value={fields.associatedOrganizationId}
              filterFunction={org => org.active}
              onChange={onFieldChange("associatedOrganizationId")}
              onBlur={() =>
                handleBlur(
                  "associatedOrganizationId",
                  fields.associatedOrganizationId,
                )
              }
              error={hasValidationError("associatedOrganizationId")}
              helperText={firstValidationError("associatedOrganizationId")}
            />
          </Grid>
          <Grid item xs={12}>
            <CredentialTypeSelect
              value={fields.credentialType}
              onChange={onFieldChange("credentialType")}
              onBlur={() => handleBlur("credentialType", fields.credentialType)}
              error={hasValidationError("credentialType")}
              helperText={firstValidationError("credentialType")}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationPropertyDialog;
